import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ptBR from '@/locales/pt-BR.json'
import en from '@/locales/en.json'

i18n.use(initReactI18next).init({
  lng: 'pt-BR',
  fallbackLng: 'pt-BR',
  ns: ['console'],
  defaultNS: 'console',
  resources: {
    'pt-BR': { console: ptBR },
    en: { console: en },
  },
  interpolation: { escapeValue: false },
})

export { i18n }
